<template>
<div class="contentBox liveSharePage">
    <div class="pageTitle">
        <el-steps :active="2" simple finish-status="wait" style="padding-left: 0">
            <el-step title="编辑" icon="el-icon-edit" @click.native="jumpNavPage('/onDemand/edit')"></el-step>
            <el-step title="文件管理" icon="el-icon-files" @click.native="jumpNavPage('/onDemand/file')"></el-step>
            <el-step title="分享" icon="el-icon-share"></el-step>
            <el-step title="访问统计" icon="el-icon-data-analysis" @click.native="jumpNavPage('/onDemand/statistics')"></el-step>
        </el-steps>
    </div>
    <div class="advanceds">
        <div class="title">
            <span>页面分享</span>
        </div>
        <div class="advancedInfo">
            <div class="infoItem">
                <span class="label">网页地址</span>
                <el-input placeholder="请输入内容" class="w600" v-model="webAddress">
                    <el-button slot="append" type="primary" v-clipboard:copy="webAddress" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</el-button>
                </el-input>
            </div>
            <div class="infoItem">
                <span class="label">二维码</span>
                <div class="qrcodeBox">
                    <img :src="qrData" style=" width: 100%;" alt />
                </div>
            </div>
        </div>
    </div>


</div>
</template>

<script>
    import common from '../../common.vue';

    const GET_VOD_SHARE_URL = common._BASE_ + 'vod/shareConfig';

    export default {
        name: "ChannelShare",
        data() {
            return {
                webAddress: '',
                hoursData: '',
                qrData: '',
                vodId: -1
            };
        },
        methods: {
            // 复制成功
            onCopy() {
                this.$message({
                    message: '复制成功！',
                    type: 'success'
                })
            },
            // 复制失败
            onError() {
                this.$message({
                    message: '复制失败！',
                    type: 'error'
                })
            },
            initPage(vodId) {
                console.log(vodId);
                let _this = this;
                if (vodId) {
                    let data = Object.assign({vodId: vodId});
                    _this.vodId = vodId;
                    _this.$axios.post(GET_VOD_SHARE_URL, this.$qs.stringify(data)).then(function (res) {
                        console.log(res);
                        let share = res.data.share;
                        _this.webAddress = share.pageUri;
                        _this.qrData = 'data:image/png;base64,' + share.qrData;
                    });
                }

            },

            jumpNavPage(path) {
                let _this = this;
                _this.$router.push({
                    path: path + "/" + _this.vodId
                });
            }
        },
        mounted() {
            this.initPage(this.$route.params.id || this.$route.query.id);
        }
};
</script> 

<style lang="less">
.liveSharePage {
    .advanceds {
        width: 1210px;
        background: #ffffff;
        border: 1px solid #e8e8e8;
        margin: 15px 0;

        .tipsBox {
            height: 44px;
            margin: 0 25px;
            display: flex;
            align-items: center;
            font-size: 12px;
            font-weight: 400;
            line-height: 26px;
            color: #7e868c;
            border-bottom: 1px dashed #e8e8e8;

            img {
                margin-right: 6px;
            }
        }

        .title {
            height: 44px;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-bottom: 1px solid #e9e9e9;
            padding: 0 21px;
            font-size: 16px;
            font-weight: bold;
            color: #221816;

            span::before {
                content: "";
                display: inline-block;
                width: 4px;
                height: 12px;
                background: #306ff6;
                border-radius: 3px;
                margin-right: 6px;
            }
        }

        .infoItem {
            display: flex;
            align-items: center;
            margin-bottom: 22px;
            margin-bottom: 17px;
        }

        .qrcodeBox {
            width: 138px;
            height: 138px;
            background: #ffffff;
            border: 1px solid #c1c5c5;
            border-radius: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .w600 {
            width: 600px;
        }

        .label {
            width: 83px;
            font-size: 14px;
            font-weight: 400;
            line-height: 21px;
            color: #221816;
        }

        .advancedInfo {
            padding: 16px 32px;
            font-size: 14px;
            font-weight: 400;
            line-height: 21px;
            color: #221816;
        }

        .el-input-group__append {
            cursor: pointer;
        }
    }
}
</style>